import { ExchangeFolderId } from "client/Api/Email/common";
import { EmailIdWithIsReadStatus } from "client_legacy/Email/emailEvents";
import { DraggableData } from "client_legacy/ndaw/drag-and-drop/globalDraggableIdentities";

export interface EmailDraggableData extends DraggableData {
	sourceFolderId: ExchangeFolderId;
	smtpAddress: string | null;
	emails: readonly EmailIdWithIsReadStatus[];
	draggableIdentity: "emailItem";
}

export type EmailDragStartCallbackData = {
	draggableData: EmailDraggableData;
	tooltip: HTMLElement;
};

export const EMAIL_DRAGGABLE_DATA_IDENTIFIER = "application/email-list";